import WebGalleryMemoryBookAlbum from './WebGalleryMemoryBookAlbum';

export default WebGalleryMemoryBookAlbum;
